import script from "./xt_spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_spinner.vue?vue&type=script&setup=true&lang=js"

import "./xt_spinner.vue?vue&type=style&index=0&id=6010653c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6010653c"]])

export default __exports__